import type { RootState } from '../types/store';
import getHostingPackages from './hosting-packages';
import messenger from '../messenger';
import type { HostingPackage, HostingPackages } from '../types/hosting-package';
import getLowestPackage from '../helpers/get-lowest-package';
import isPaidHostingPackageType from '../verifiers/is-paid-hosting-package-type';

function getLowestAvailablePaidHostingPackage(rootState: RootState): HostingPackage {
  const hostingPackages = getHostingPackages(rootState);

  if (!hostingPackages) {
    throw new Error(messenger.missingData('hostingPackages'));
  }

  const hostingPaidPackages = Object.fromEntries(
    Object.entries(hostingPackages).filter(([, { type: packageType }]) =>
      isPaidHostingPackageType(packageType)
    )
  );

  return getLowestPackage<HostingPackage, HostingPackages>(hostingPaidPackages);
}

export default getLowestAvailablePaidHostingPackage;
